import { PolygonFeatureLabel3D } from 'features/assetViz/objects/features/procedural/PolygonFeatureLabel3D'
import {
  SurfaceLineFeature3D,
  SurfaceLineSelectionType,
} from 'features/assetViz/objects/features/procedural/SurfaceLineFeature3D'
import {
  SurfaceMeshFeature3D,
  SurfaceMeshSelectionType,
} from 'features/assetViz/objects/features/procedural/SurfaceMeshFeature3D'
import { useSurfaceProps } from 'features/assetViz/objects/surfaces/util/SurfaceProvider'
import React, { FC, useMemo } from 'react'
import { GeckoComponentPolygon, GeckoShipDeckCompartment } from 'types'

export const DeckCompartmentFeature3D: FC<{
  model: GeckoShipDeckCompartment
}> = ({ model }) => {
  const { bounds, wrapMode } = useSurfaceProps()

  const boundingPath = useMemo(
    () =>
      GeckoComponentPolygon.CreateFromPolygonalPlate(
        model.geometry,
        bounds,
        wrapMode
      ),
    [bounds, model.geometry, wrapMode]
  )

  return (
    <group key={model.id}>
      <SurfaceLineFeature3D
        path={boundingPath}
        featureModel={model}
        lineSelectionType={SurfaceLineSelectionType.SelectableFeatureLine}
      />
      <SurfaceMeshFeature3D
        path={boundingPath}
        featureModel={model}
        selectionType={SurfaceMeshSelectionType.AssetModelEditorSelectable}
        userDataName={'shipDeckCompartment'}
      />
      <PolygonFeatureLabel3D feature={model} polygonPath={boundingPath} />
    </group>
  )
}
